module.exports = __webpack_public_path__ + "img/icon_tool@2x.49a66a0f.png";